/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 2/19/16.
 */
'use strict';
angular.module('prism-ui.calendars').service('CalendarsFilterService', function () {
	var CalendarsFilterService = this;
	var searchFields = ['episodeTitle'];
	CalendarsFilterService.searchText = '';

	var matchesSearchFields = function (data) {
		var matcher = new RegExp(CalendarsFilterService.searchText.toLowerCase());
		for (var key in searchFields) {
			var searchVal = data[searchFields[key]];
			if (searchVal && searchVal.toLowerCase().match(matcher)) {
				return true;
			}
		}
		return false;
	};

	var filterDueDateSectionsForToday = function (collection, dateProp, today) {
		var returnVal = [];
		angular.forEach(collection.data, function (item) {
			if (new Date(item[dateProp]).setHours(0, 0, 0, 0) === today.getTime() && matchesSearchFields(item)) {
				returnVal.push(item);
			}
		});
		return returnVal;
	};

	var filterDueDateForToday = function (todayKey, collection) {
		var returnValue = {};
		if (collection.Overdue) {
			returnValue.Overdue = {
				data: filterDueDateSectionsForToday(collection.Overdue, 'dueDate', todayKey),
				style: 'overdue-cal-header'
			};
		}
		if (collection.Warning) {
			returnValue.Warning = {
				data: filterDueDateSectionsForToday(collection.Warning, 'warningDueDate', todayKey),
				style: 'warning-cal-header'
			};
		}
		return returnValue;
	};

	CalendarsFilterService.filterToday = function (collection, calendar) {
		var todayKey = new Date(new Date().setHours(0, 0, 0, 0));
		var newData = {};
		var dateData = collection[todayKey];
		if (dateData) {
			var searchable = {};
			searchable[todayKey] = dateData;
			newData = CalendarsFilterService.executeSearch(searchable);
		}
		if (calendar === 'dueDate') {
			var dueSpecialSections = filterDueDateForToday(todayKey, collection);
			newData.Overdue = dueSpecialSections.Overdue;
			newData.Warning = dueSpecialSections.Warning;
		}
		return newData;
	};

	CalendarsFilterService.executeSearch = function (toFilter) {
		var newData = {};

		if (!CalendarsFilterService.searchText || !CalendarsFilterService.searchText.length) {
			return toFilter;
		}
		angular.forEach(toFilter, function (dateData, itemKey) {
			angular.forEach(dateData.data, function (calObject) {
				if (matchesSearchFields(calObject)) {
					var keyData = newData[itemKey];
					if (!keyData) {
						keyData = {data: [], style: dateData.style};
						newData[itemKey] = keyData;
					}
					newData[itemKey].data.push(calObject);
				}
			});
		});
		return newData;
	};
});
